
import React from 'react';
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/fecoslogo.png";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();

  if (location.pathname.startsWith("/admin")) {
    return null;
  }

  const footerLinks = [
    {
      title: t("footer.aboutUs"),
      links: [
        { name: t("navbar.about"), href: "/about" },
        { name: t("footer.certificates"), href: "#" },
        { name: t("navbar.contact"), href: "/contact" }
      ]
    },
    {
      title: t("footer.legal"),
      links: [
        { name: t("footer.privacy"), href: "/documents/gizlilik-politikasi.pdf", external: true },
        { name: t("footer.refund"), href: "/documents/iade-ve-iptal.pdf", external: true },
        { name: t("footer.sales"), href: "/documents/satis-sozlesmesi.pdf", external: true }
      ]
    }
  ];

  return (
    <footer className="bg-[#1D1D1F] text-gray-400 py-20 text-[13px]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 lg:gap-24 mb-16">

          {/* Brand Column */}
          <div className="space-y-6 col-span-1 md:col-span-1">
            <Link to="/" className="block">
              <img src={logo} className="h-16 w-auto object-contain invert opacity-90" alt="Fecos Logo" />
            </Link>
            <p className="leading-relaxed max-w-xs">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Links Columns */}
          {footerLinks.map((section, idx) => (
            <div key={idx}>
              <h4 className="font-semibold text-white mb-6 uppercase tracking-wider text-[11px]">{section.title}</h4>
              <ul className="space-y-4">
                {section.links.map((link, lIdx) => (
                  <li key={lIdx}>
                    {link.external ? (
                      <a href={link.href} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                        {link.name}
                      </a>
                    ) : (
                      <Link to={link.href} className="hover:text-white transition-colors">
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Newsletter (Simplified) */}
          <div>
            <h4 className="font-semibold text-white mb-6 uppercase tracking-wider text-[11px]">{t("footer.stayUpdated")}</h4>
            <p className="mb-4">{t("footer.subscribeText")}</p>
            <div className="flex items-center border-b border-gray-700 py-2 focus-within:border-white transition-colors">
              <input
                type="email"
                placeholder={t("footer.emailPlaceholder")}
                className="bg-transparent border-none outline-none text-white w-full placeholder-gray-600 focus:ring-0"
              />
              <button className="text-white hover:text-fecos-accent transition-colors">
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p>&copy; 2025 FecosFood. {t("footer.rights")}.</p>
          <div className="flex gap-6">
            <span className="text-gray-500">{t("footer.country")}</span>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
